import { render, staticRenderFns } from "./liveDetail.vue?vue&type=template&id=268fd783"
import script from "./liveDetail.vue?vue&type=script&lang=js"
export * from "./liveDetail.vue?vue&type=script&lang=js"
import style0 from "./liveDetail.vue?vue&type=style&index=0&id=268fd783&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports